/* Homepage 2026: carrousels (voortgangsbalk + pijlen) en FAQ (één vraag tegelijk open,
   ook in browsers zonder ondersteuning voor details[name]). */
(function () {
  'use strict';

  document.querySelectorAll('.sm26-rail').forEach(function (rail) {
    var track = rail.querySelector('.sm26-rail__track');
    if (!track) return;
    var bar = rail.querySelector('.sm26-rail__progress span');
    var btns = rail.querySelectorAll('.sm26-rail__btn');
    var ticking = false;

    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 2;
      if (bar) {
        var ratio = scrollable ? track.clientWidth / track.scrollWidth : 1;
        var pos = scrollable ? track.scrollLeft / max : 0;
        bar.style.width = (ratio * 100) + '%';
        bar.style.marginLeft = (pos * (1 - ratio) * 100) + '%';
      }
      btns.forEach(function (b) {
        var dir = +b.getAttribute('data-dir');
        b.disabled = !scrollable || (dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2);
      });
    }

    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    // Afstand van tegel tot tegel, gemeten (klopt ook als de tussenruimte per schermbreedte verschilt)
    function stepSize() {
      var a = track.children[0], b = track.children[1];
      if (a && b) return b.offsetLeft - a.offsetLeft;
      return track.clientWidth * 0.8;
    }
    // Zelf animeren (ease-out, 450 ms) i.p.v. de browser-snap: anders springt de rij in een flits terug.
    // Snap staat tijdens de animatie uit (klasse is-dragging) en gaat daarna weer aan.
    var anim = null;
    function goTo(index) {
      var max = track.scrollWidth - track.clientWidth;
      var to = Math.max(0, Math.min(max, index * stepSize()));
      var from = track.scrollLeft, t0 = null, dur = 450;
      if (anim) cancelAnimationFrame(anim);
      track.classList.add('is-dragging');
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        track.scrollLeft = from + (to - from) * e;
        if (k < 1) { anim = requestAnimationFrame(tick); }
        else { anim = null; track.classList.remove('is-dragging'); }
      }
      anim = requestAnimationFrame(tick);
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = Math.round(track.scrollLeft / stepSize());
        goTo(cur + (+b.getAttribute('data-dir')) * 2);
      });
    });

    // Klik op de balk: spring naar die plek in de rij
    var progress = rail.querySelector('.sm26-rail__progress');
    if (progress) {
      progress.addEventListener('click', function (e) {
        var r = progress.getBoundingClientRect();
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2 || !r.width) return;
        var ratio = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        track.scrollTo({ left: ratio * max, behavior: 'smooth' });
      });
    }

    // Desktop: slepen met de muis (touch scrollt al vanzelf). Zelfde gevoel als Swiper:
    // de rij volgt de muis 1-op-1; bij loslaten door naar de volgende tegel als je meer dan een vijfde
    // tegel sleepte of snel zwiepte, anders veert hij terug. Altijd eindigen met een tegel strak links.
    var drag = null, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (track.scrollWidth - track.clientWidth <= 2) return;
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      var now = Date.now();
      drag = { x: e.clientX, left: track.scrollLeft, start: Math.round(track.scrollLeft / stepSize()), lastX: e.clientX, lastT: now, v: 0 };
      moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) {
        var now = Date.now();
        drag.v = (e.clientX - drag.lastX) / Math.max(1, now - drag.lastT);   // px per ms
        drag.lastX = e.clientX; drag.lastT = now;
        track.scrollLeft = drag.left - dx;
        e.preventDefault();
      }
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return;
      var d = drag; drag = null;
      if (!moved) return;
      var dx = e.clientX - d.x, step = stepSize(), target = d.start;
      if (Math.abs(dx) > step * 0.2 || Math.abs(d.v) > 0.5) {
        var n = Math.max(1, Math.round(Math.abs(dx) / step));
        target = d.start + (dx < 0 ? n : -n);
      }
      goTo(target);
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    update();
  });

  // Carrousels: zodra een carrousel (bijna) in beeld komt, alle foto's ervan meteen laden.
  // Anders laadt de browser foto's in een horizontale rij pas tijdens het swipen en zie je even een leeg vak.
  var railImgs = document.querySelectorAll('.sm26-rail__track, .sm-htw__grid');
  if (railImgs.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        io.unobserve(en.target);
      });
    }, { rootMargin: '400px 0px' });
    railImgs.forEach(function (t) { io.observe(t); });
  }

  // Cadeau-banner: looptijden en laagste prijs live uit het dashboard (gift_card_plans, NL-prijs)
  var cadDuur = document.querySelector('[data-sm-cadeau-duur]'), cadPrijs = document.querySelector('[data-sm-cadeau-prijs]');
  if (cadDuur || cadPrijs) {
    var base = (window.SMELLISH_API_BASE || 'https://smellish-auth.onrender.com').replace(/\/$/, '');
    fetch(base + '/api/giftcards/plans').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var plans = (d && d.success && d.plans || []).filter(function (p) { return p.enabled; });
      if (!plans.length) return;
      plans.sort(function (a, b) { return a.duration_months - b.duration_months; });
      var m = plans.map(function (p) { return p.duration_months; });
      if (cadDuur) cadDuur.textContent = m.length > 1 ? m.slice(0, -1).join(', ') + ' of ' + m[m.length - 1] : String(m[0]);
      var min = Math.min.apply(null, plans.map(function (p) { return Number(p.price); }));
      if (cadPrijs && isFinite(min)) cadPrijs.textContent = '€' + (min % 1 ? min.toFixed(2).replace('.', ',') : String(min));
    }).catch(function () {});
  }

  // FAQ: één tegelijk open (fallback voor details[name])
  var items = document.querySelectorAll('.sm26-faq__item');
  items.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
    });
  });
})();
